import {useContext} from 'react';
import VillageContext, {VillageContextProps} from '@/contexts/villageContext';

const useVillageContext = (): VillageContextProps => {
  const context = useContext(VillageContext);

  if (!context) {
    throw new Error(
      'useVillageContext must be used within an VillageContextProvider',
    );
  }

  return context;
};

export default useVillageContext;
